import request from '@/utils/request'

export const saveSystemInfo = (record) =>
    request({
        url: '/web/systeminfo/save',
        method: 'post',
        data: record
    })

export const getSystemInfoById = (id) =>
    request({
        url: '/web/systeminfo/detail?id=' + id,
        method: 'get'
    })

export const updateSystemInfo = (id, record) =>
    request({
        url: '/web/systeminfo/save',
        method: 'post',
        data: record
    })

export const listAllSystemInfo = () =>
    request({
        url: '/web/systeminfo/page',
        method: 'get'
    })
export const deleteSystemInfo = (id) =>
    request({
        url: '/web/systeminfo/delete',
        method: 'post',
        data:{id: id}
    })



// WEBPACK FOOTER //
// ./src/api/web/systeminfo.js